import React from "react";
import LandmarkLogo from "../LandmarkLogo";
import { Headshot, firstNameOf } from "./shared";

// Soft cream-to-sage gradient with an arch-shaped photo and pill tags.
export default function Arch({ data, headshot }) {
  const first = firstNameOf(data.name) || "Name";
  return (
    <div className="wp-canvas wp-t-arch">
      <div className="wp-t-arch__glow" />

      <header className="wp-t-arch__top">
        <LandmarkLogo width={230} />
        <span className="wp-t-arch__eyebrow">New team member</span>
      </header>

      <div className="wp-t-arch__photo-wrap">
        <div className="wp-t-arch__shadow" />
        <Headshot headshot={headshot} className="wp-t-arch__photo" />
      </div>

      <div className="wp-t-arch__copy">
        <h1>
          Welcome, <em>{first}</em>
        </h1>
        {data.tagline && <p className="wp-t-arch__tagline">{data.tagline}</p>}
        {(data.role || data.team) && (
          <div className="wp-t-arch__tags">
            {data.role && <span>{data.role}</span>}
            {data.team && <span className="wp-t-arch__tag--solid">{data.team}</span>}
          </div>
        )}
      </div>

      {data.note && <div className="wp-t-arch__note">{data.note}</div>}
    </div>
  );
}
